<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">Reset Password</span>
    <a class="button waves-effect" (click)="onCloseClick()">
      <i class="material-icons button__icon">cancel</i>
      <span class="button__text">Close</span>
    </a>
  </div>

  <div class="ttmodal__body">
    <div class="column-container flex-grow" style="margin-left: 1%; margin-bottom: 30px;">
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            {{ 'Username' | translate | async }}
          </span>
          <span class="text-block__important">
            {{userName}}
          </span>
        </div>
      </div>
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            {{ 'Email' | translate | async }}
          </span>
          <span class="text-block__important">
            <a href="mailto:{{email}}">{{email}}</a>
          </span>
        </div>
      </div>
    </div>

    <!-- Password -->
    <div class="flex-row">
      <mat-form-field style="width: 100%;">
        <input matInput
               placeholder="Password"
               [type]="hidePassword ? 'password' : 'text'"
               [(ngModel)]="password"
               name="password"
               required>

        <button mat-icon-button matSuffix type="button" tabindex="-1"
                (click)="hidePassword = !hidePassword">
          <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <!-- Confirm Password -->
    <div class="flex-row">
      <mat-form-field style="width: 100%;">
        <input matInput
               placeholder="Confirm Password"
               [type]="hideConfirm ? 'password' : 'text'"
               [(ngModel)]="confirmPassword"
               name="confirmPassword"
               required>

        <button mat-icon-button matSuffix type="button" tabindex="-1"
                (click)="hideConfirm = !hideConfirm">
          <mat-icon>{{ hideConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>

      </mat-form-field>
    </div>

  </div>

  <div class="ttmodal__footer">
    <div class="footer-left-pan">
      <div>
        <button mat-raised-button (click)="onCloseClick()" tabindex="-1">
          {{ "Cancel" | translate | async }}
        </button>
      </div>

      <div style="margin-left: 10px;">
        <button mat-raised-button
                color="warn"
                class="save-btn"
                [class.loading]="saving"
                (click)="onSave()">
          {{ "Reset" | translate | async }}
        </button>
      </div>
    </div>
  </div>
</div>
